import React, {Component} from "react";
import moment from "moment";
import "./NSREDatePicker.css"
// import {NassauLog} from "../scripts/myga-utils";

const MIN_AGE = 0;
const MAX_AGE = 120;


class NSREDatePicker extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      month: '',
      day: '',
      year: ''
    };
    this.required = false;
    if (this.props.required!==undefined) {
      this.required = this.props.required !== false;
    }
    if (this.props.maxDate!==undefined) {
      this.maxDate = this.props.maxDate;
    } else {
      this.maxDate = moment().subtract(MIN_AGE, "years").toDate()
    }
    if (this.props.minDate!==undefined) {
      this.minDate = this.props.minDate;
      // NassauLog('minDate: ' + moment(this.minDate).format('YYYY-MM-DD'));
    } else {
      this.minDate = moment().subtract(MAX_AGE, "years").toDate()
    }
    this.maxYear = moment(this.maxDate).format('YYYY');
    this.minYear = moment(this.minDate).format('YYYY');
    // NassauLog(`minYear: ${this.minYear}`);
    this.dataFormat = this.props.dataFormat || "YYYY-MM-DD";
    
    this.yearOrderAscending = (this.props.yearOrderAscending!==undefined)?this.props.yearOrderAscending:true;

    this.name = props.name;
  }
  
  set value(str) {
    // if (date===undefined || date===null) return;
    let m = moment(str,this.dataFormat);
    this.setState({
      month: m.isValid()?m.format('MM'):'',
      day: m.isValid()?m.format('DD'):'',
      year: m.isValid()?m.format('YYYY'):''
    },()=>{
      // let str = this.state.year + '-' + this.state.month + '-' + this.state.day;
      // NassauLog('set value: ' + str);
    });
  }
  
  get value() {
    // Only return a value if a month, day, and year have been selected
    if (this.state.year && this.state.month && this.state.day) {
    let str = this.state.year + '-' + this.state.month + '-' + this.state.day;
    return moment(str,'YYYY-MM-DD').format(this.dataFormat);
  }
    return '';
  }
  
  get date() {
    let str = this.state.year + '-' + this.state.month + '-' + this.state.day;
    return moment(str,'YYYY-MM-DD').toDate();
  }
  
  get isSelectedValid() {
    let str = this.state.year + '-' + this.state.month + '-' + this.state.day;
    let t = this.date.getTime();
    return (
        moment(str,'YYYY-MM-DD').isValid() &&
        (this.minDate.getTime()<=t) &&
        (t<=this.maxDate.getTime())
    );
  }
  
  componentDidMount() {
    if (this.props.value!==null) {
      this.value = this.props.value;
    } else {

    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.value !== prevProps.value) {
      this.value = this.props.value;
    }
  }
  
  handleChange = (e) => {
    e.preventDefault();
    let cb = ()=>{
      if (this.props.onChange!==null) {
        // let t = this.date.getTime();
        // if (t<this.minDate.getTime()) {
        //   this.props.onChange(this.minDate);
        // } else if (t>this.maxDate.getTime()) {
        //   this.props.onChange(this.maxDate);
        // } else {
          this.props.onChange(this.value);
        // }
      }
    };
    let className = e.target.className;
    if (className.indexOf('month') >= 0) {
      this.setState({ month: e.target.value},cb);
    }
    else if (className.indexOf('day') >= 0) {
      this.setState({ day: e.target.value},cb);
    }
    else if (className.indexOf('year') >= 0) {
      this.setState({ year: e.target.value},cb);
    }
  };
  
  getMonthSelector = () => {
    let options = [];
    options.push(<option key={'month_ns'} value=''>--</option>);
    for (let i=1; i<=12; ++i) {
      let s = (i<10)?'0'+i:''+i;
      options.push(<option key={'month_'+i} id={`${this.name}_month_${i}`} value={s}>{s}</option>)
    }
    let output = [];
    output.push(
        this.required ? (
            <select key={'month_sel'} ref={(el) => {this.monthSelector = el;}} className={'form-control page-input month'} value={this.state.month} onChange={this.handleChange} required>
              {options}
            </select>
        ) : (
            <select key={'month_sel'} ref={(el) => {this.monthSelector = el;}} className={'form-control page-input month'} value={this.state.month} onChange={this.handleChange}>
              {options}
            </select>
        )
    );
    
    return output;
  };
  
  getDaySelector = () => {
    let options = [];
    options.push(<option key={'day_ns'} value=''>--</option>);
    for (let i=1; i<=31; ++i) {
      let s = (i<10)?'0'+i:''+i;
      options.push(<option key={'day_'+i} id={`${this.name}_day_${i}`} value={s}>{s}</option>)
    }
    let output = [];
    output.push(
        this.required ? (
            <select key={'day_sel'} ref={(el) => {this.daySelector = el;}} className={'form-control page-input day'} value={this.state.day} onChange={this.handleChange} required>
              {options}
            </select>
        ) : (
            <select key={'day_sel'} ref={(el) => {this.daySelector = el;}} className={'form-control page-input day'} value={this.state.day} onChange={this.handleChange}>
              {options}
            </select>
        )
    );
    return output;
  };
  
  getYearSelector = () => {
    let options = [];
    options.push(<option key={'year_ns'} value=''>--</option>);
    let y0 = Number.parseInt(this.yearOrderAscending===true?this.minYear:this.maxYear);
    let y1 = Number.parseInt(this.yearOrderAscending===true?this.maxYear:this.minYear);
    let dy = (y1>y0)?1:-1;
    for (let y=y0; dy*(y1-y)>=0; y+=dy) {
      let s = '' + y;
      options.push(<option key={'year_'+y} id={`${this.name}_year_${y}`} value={s}>{s}</option>)
    }
    let output = [];
    output.push(
        this.required ? (
            <select key={'year_sel'} ref={(el) => {this.yearSelector = el;}} className={'form-control page-input year'} value={this.state.year} onChange={this.handleChange} required>
              {options}
            </select>
        ) : (
            <select key={'year_sel'} ref={(el) => {this.yearSelector = el;}} className={'form-control page-input year'} value={this.state.year} onChange={this.handleChange} >
              {options}
            </select>
        )
    );
    return output;
  };
  
  setCustomValidity = (msg) => {
    if (this.monthSelector) {
      this.monthSelector.setCustomValidity(msg);
    }
    if (this.daySelector) {
      this.daySelector.setCustomValidity(msg);
    }
    if (this.yearSelector) {
      this.yearSelector.setCustomValidity(msg);
    }
  };
  
  render() {
    
    return (
        <div className={'nsre-date-picker'}>
          <div className={'row'}>
            <div className={'select-wrap col-4'}>
              {this.getMonthSelector()}
              <div><label>month</label></div>
            </div>
            <div className={'select-wrap col-4'}>
              {this.getDaySelector()}
              <div><label>day</label></div>
            </div>
            <div className={'select-wrap col-4'}>
              {this.getYearSelector()}
              <div><label>year</label></div>
            </div>
          </div>
        </div>
    );
  }
  
}

export default NSREDatePicker;